<div class="bg-img-circule">
  <img src="../../../../assets/images/Home-2.png" />
</div>
<app-menu-template1>
  <main class="container">
    <section class="home-mt-seccion">
      <header class="col-sm-8 col-md-4">
        <h1 class="home-titulo-width text-white h3">Registro Nacional de Turismo (RNT)</h1>
        <p class="home-titulo-width text-white">Registro público, en el cual deben inscribirse todos
          los prestadores de servicios turísticos que
          efectúen sus operaciones en Colombia.</p>
      </header>
      <aside>
        <ngu-carousel #myCarousel [inputs]="configCarouselTile" [dataSource]="tarjetas">
          <button NguCarouselPrev class="carousel-control-prev btn col-1 text-secondary" [style.opacity]="myCarousel.isFirst ? 0.1:1"
            *ngIf="tarjetas.length>3">
            <span aria-hidden="true">
              <img src="../../../../assets/icons/circul-arrow-left.png" />
            </span>
            <span class="sr-only">Previous</span>
          </button>
          <ngu-tile *nguCarouselDef="let item; let i = index" class="home-carusel-tile mt-5">
            <app-tarjeta [tarjeta]="item">
              <p class="card-text home-carusel-card-text" [innerHTML]="item.descripcion"></p>
            </app-tarjeta>
          </ngu-tile>
          <button NguCarouselNext class="carousel-control-next btn col-1 text-secondary" [style.opacity]="myCarousel.isLast ? 0.1:1"
            *ngIf="tarjetas.length>3">
            <span aria-hidden="true">
              <img src="../../../../assets/icons/circul-arrow-right.png" />
            </span>
            <span class="sr-only">Next</span>
          </button>
        </ngu-carousel>
      </aside>
    </section>
    <article class="row" *ngIf="tarjetasPasos && tarjetasPasos.length > 0">
      <section class="col-sm align-self-center">
        <div class="row">
          <header class="col-sm home-pasos-titulo">
            <h1>
              <strong>{{tarjetasPasos.length}}</strong>
            </h1>
          </header>
          <footer class="col-sm m-auto">
            <header>
              <h2 class="h1"><strong>pasos</strong></h2>
            </header>
            <p><strong>Para radicar el formulario de inscripción</strong></p>
            <aside class="text-muted">
              Lo invitamos a seguir este sencillo proceso.
            </aside>
          </footer>
        </div>
      </section>
      <aside class="col-sm">
        <ul class="list-group">
          <li *ngFor="let item of tarjetasPasos" class="list-group-item home-list-group-item home-pasos-num" [ngClass]="item.activo ? 'activado' : ''"
            [attr.data-num]="item.orden">
            <app-tarjeta-pasos [tarjetaPasos]="item"></app-tarjeta-pasos>
          </li>
        </ul>
      </aside>
    </article>
  </main>
  <nav class="navbar navbar-dark bg-dark mt-5">
    <header class="navbar-expand m-auto col-sm-12">
      <div class="navbar-nav row m-auto d-flex flex-row justify-content-between">
        <label class="nav-item max-ancho" *ngFor="let item of links">
          <ul class="nav flex-column">
            <li class="nav-item">
              <label class="nav-link active h5 mt-2 pb-0" href="#">{{item.titulo}}</label>
            </li>
            <li class="nav-item" *ngFor="let itemPI of item.post_interes">
              <a class="nav-link pointer pb-0 pt-0" (click)="onOpenWindow(itemPI.ruta_url)">{{itemPI.descripcion}}</a>
            </li>
          </ul>
        </label>
      </div>
    </header>
  </nav>
</app-menu-template1>